export const SUPER_ADMIN_EMAILS = new Set([
    'srinivasan@helixops.ai',
    'jithesh@helixops.ai',
    'manishkumar@helixops.ai',
    'bharati@helixops.ai',
    'anirudh@helixops.ai'
]);

export const SUPER_ADMIN_EMAILS_DEV = new Set([
    'srinivasan@helixops.ai',
    'jithesh@helixops.ai',
    'manishkumar@helixops.ai',
    'bharati@helixops.ai',
    'anirudh@helixops.ai'
]);
